import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonRow, IonCol, IonCard, IonCardContent, IonIcon, IonFab, IonFabList, IonFabButton, IonList, IonItem, IonButtons, IonBackButton, IonAvatar, IonLabel } from '@ionic/react';
import './customer.css';
import { add } from 'ionicons/icons'
import axios from "axios";
import getApi from '../api';
import EnvironmentBadge from '../components/EnvironmentBadge';
import React, { useState } from 'react';
import { useParams } from 'react-router';
import { useLocalStorage } from '../components/useLocalStorage'
import { useIonViewDidEnter } from '@ionic/react';
import { useHistory } from "react-router-dom";

const Customer: React.FC = () => {

  const { id } = useParams<{ id: string }>();
  let [Customer, setCustomer] = useLocalStorage("customer", "");
  let [OrderResults, setOrderResults] = useState([]);
  let [OfferResults, setOfferResults] = useState([]);
  // let [OfferResult, setOfferResult] = useLocalStorage("offer", "");
  // let [OrderResult, setOrderResult] = useLocalStorage("order", "");
  const history = useHistory();


  const api = getApi();

  useIonViewDidEnter(() => {
    // setOfferResult("");
    // setOrderResult("");
    
    api.get("/fortnox/customers/"+id+"/")
      .then(res => {
        //console.log(res.data.Customer)
        setCustomer(res.data.Customer);
        console.log(Customer);
        
        api.get("/fortnox/orders/?customernumber="+res.data.Customer.CustomerNumber+"&sent=False")
        .then(res => {
          console.log(res.data.Orders)
          setOrderResults(res.data.Orders);
        })

        api.get("/fortnox/offers/?customernumber="+res.data.Customer.CustomerNumber+"&sent=False")
        .then(res => {
          //console.log(res.data.Orders)
          setOfferResults(res.data.Offers);
        })
      })

    });

    function createorder(){
      api.post('/fortnox/orders/new/', {
        id: Customer.CustomerNumber
      })
      .then(function (response) {
        console.log(response.data.Order.DocumentNumber);
        history.push("/Order/"+response.data.Order.DocumentNumber);
      })
      .catch(function (error) {
        console.log(error);
      });
    }

    function createoffer(){
      api.post('/fortnox/offer/new/', {
        id: Customer.CustomerNumber
      })
      .then(function (response) {
        console.log(response.data.Offer.DocumentNumber);
        history.push("/Offer/"+response.data.Offer.DocumentNumber);
      })
      .catch(function (error) {
        console.log(error);
      });
    }


  return (
    <IonPage placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
      <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonToolbar color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonButtons slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonBackButton />
        </IonButtons>
          <IonTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{ Customer.Name }</IonTitle>
          <div slot="end" style={{paddingRight:'8px'}}><EnvironmentBadge /></div>
        </IonToolbar>
      </IonHeader>

      <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Orgsnummer:</IonCol>
                <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}> { Customer.OrganisationNumber } </IonCol>
              </IonRow>
            </IonItem>
            <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Kontaktperson:</IonCol>
                <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}> { Customer.YourReference } </IonCol>
              </IonRow>
            </IonItem>
          </IonList>
        </IonCardContent>
      </IonCard>
      <IonContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>

      <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonAvatar slot="end" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          </IonAvatar>
          <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <h1>Öppna ordrar</h1>
          </IonLabel>
        </IonItem>
        <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          { OrderResults.map(result => {
            if(result["Cancelled"] !== true)
             return <IonItem routerLink={"/Order/" + result['DocumentNumber']} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <h2>Ordernummer: {result["DocumentNumber"]}</h2>
                      <h3>Kund: {result["CustomerName"]}</h3>
                      <p>Skapad: {result["OrderDate"]}</p>
                    </IonLabel>
                  </IonItem> 
            return null;
          })}
          </IonList>
        </IonCardContent>
      </IonCard>

      <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonAvatar slot="end" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          </IonAvatar>
          <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <h1>Öppna offerter</h1>
          </IonLabel>
        </IonItem>
        <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          { OfferResults.map(result => {
            if(result["Cancelled"] !== true)
            return <IonItem routerLink={"/Offer/" + result['DocumentNumber']} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <h2>Offertnummer: {result["DocumentNumber"]}</h2>
                      <h3>Kund: {result["CustomerName"]}</h3>
                      <p>Skapad: {result["OfferDate"]}</p>
                    </IonLabel>
                  </IonItem>
            return null;
          })}
          </IonList>
        </IonCardContent>
      </IonCard>

      <IonFab slot="fixed" vertical="bottom" horizontal="end" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonFabButton placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonIcon icon={add} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
          </IonFabButton>
          <IonFabList side="top" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonFabButton class="ion-fab-button-child" color="primary" onClick={() => createorder()} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              Order
            </IonFabButton>
            <IonFabButton class="ion-fab-button-child" color="primary" onClick={() => createoffer()} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              Offert
            </IonFabButton>
          </IonFabList>
        </IonFab>

      </IonContent>
    </IonPage>
  );
};

export default Customer;
